/** AP-39 — Bezeichnungen, die Posteingang und Block „Eingänge" teilen. */
import type { InboxKind } from '@symphenia/shared-types'

export const ART_TEXT: Record<InboxKind, string> = {
  OFFER: 'Angebot',
  ORDER_CONFIRMATION: 'Auftragsbestätigung',
  INVOICE: 'Rechnung',
  SUPPLIER_DELIVERY_NOTE: 'Lieferschein des Lieferanten',
  SIGNED_DELIVERY_NOTE: 'unterschriebener Lieferschein',
  CERTIFICATE: 'Zeugnis',
  OTHER: 'sonstiges',
  UNKNOWN: 'unbekannt',
}

/** Das Ziel im Register zu einer Belegart (8.1) — nur diese Arten tragen den Block „Eingänge". */
export const BELEG_ZIEL: Partial<Record<string, string>> = {
  INQUIRY: 'DOCUMENT_INQUIRY',
  PURCHASE_ORDER: 'DOCUMENT_PURCHASE_ORDER',
  DELIVERY_NOTE: 'DOCUMENT_DELIVERY_NOTE',
}
